import React, { useContext, useState,useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
import SubFormButtons from "../SubFormButtons";
import findBrand from "../../findBrand";
import raceCategoryList from "../../../data/raceCategoryList";
import ProgressButtons from "../ProgressButtons";
import { brandDomains, fetchBrands } from "../../brand";



const R6Ethnicity = () => {
  const registrationContext = useContext(RegistrationContext);

  const {
    subFormLevels,
    formData: { isStudentHispanicOrLatino, firstName, primaryRaceCategory },
    onFormDataChange,
    pass: { ethnicity },
  } = registrationContext;

  const ethicityFilledout =
    isStudentHispanicOrLatino == "" ||
    (isStudentHispanicOrLatino !== "" && primaryRaceCategory == "") ||
    primaryRaceCategory;

  const ethicityFilledout1 =
    isStudentHispanicOrLatino !== "" && primaryRaceCategory !== "";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  useEffect(() => {
       const loadBrands = async () => {
         await fetchBrands();
       };
   
       loadBrands();
     }, []);
  
     const brand_holston = brandDomains.brand_holston?.name;
     const brand_pbia = brandDomains.brand_pbia?.name;
    
  //findBrand is used to check whether holston forms or other forms
  if (findBrand( brand_holston) === true || findBrand(brand_pbia) === true) {
    return (
      <>
        <div className="sub-form">
          <h2>
            Ethnicity <span>(7/11)</span>
            <hr />
          </h2>
          {!ethnicity && (
            <p className="validation-msg">
              Please fill out the required fields
            </p>
          )}
          <div className="item">
            <div className="asterisk-group">
              <h3>
                Is {firstName === "" ? "the Student" : firstName} Hispanic or
                Latino?
              </h3>
            </div>
            <div
              className="flex-check-container"
              style={{
                border: ethnicity
                  ? "1px solid #ccc;"
                  : isStudentHispanicOrLatino !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={isStudentHispanicOrLatino["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="isStudentHispanicOrLatino"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={isStudentHispanicOrLatino["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="isStudentHispanicOrLatino"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What Is {firstName === "" ? "the Student" : firstName}'s Primary
                Race Category?
              </h3>
            </div>
            <select
              name="primaryRaceCategory"
              value={primaryRaceCategory}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: ethnicity
                  ? "1px solid #ccc;"
                  : primaryRaceCategory !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {raceCategoryList.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>
        </div>
        <div className="group">{subFormLevels.ethnicity === 0}</div>
        <ProgressButtons validation={ethicityFilledout} name="ethnicity" />
      </>
    );
  } else {
    return (
      <>
        <div className="sub-form">
          <h2>
            Ethnicity <span>(5/15)</span>
            <hr />
          </h2>
          {!ethnicity && (
            <p className="validation-msg">
              Please fill out the required fields
            </p>
          )}
          <div className="item">
            <div className="asterisk-group">
              <h3>
                Is {firstName === "" ? "the Student" : firstName} Hispanic or
                Latino?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: ethnicity
                  ? "1px solid #ccc;"
                  : isStudentHispanicOrLatino !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={isStudentHispanicOrLatino["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="isStudentHispanicOrLatino"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={isStudentHispanicOrLatino["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="isStudentHispanicOrLatino"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What Is {firstName === "" ? "the Student" : firstName}'s Primary
                Race Category?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="primaryRaceCategory"
              value={primaryRaceCategory}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: ethnicity
                  ? "1px solid #ccc;"
                  : primaryRaceCategory !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {raceCategoryList.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>
        </div>
        <div className="group">{subFormLevels.ethnicity === 0}</div>
        <ProgressButtons validation={ethicityFilledout1} name="ethnicity" />
      </>
    );
  }
};

export default R6Ethnicity;

